import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createContext, useCallback, useState } from 'react';
import { isSomethingLoading } from '../../redux/general/general.selectors';
import { useSelector } from 'react-redux';
export var LoaderContext = createContext({
    open: function () {
        throw new Error('No open method assigned to the provider');
    },
    close: function () {
        throw new Error('No close method assigned to the provider');
    },
});
export var LoaderProvider = function (_a) {
    var children = _a.children, Loader = _a.Loader;
    var isFullPageLoaderLoading = useSelector(isSomethingLoading);
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var open = useCallback(function () {
        setIsLoading(true);
    }, []);
    var close = useCallback(function () {
        setIsLoading(false);
    }, []);
    return (_jsxs(LoaderContext.Provider, { value: {
            open: open,
            close: close,
        }, children: [children, isLoading || isFullPageLoaderLoading ? _jsx(Loader, {}) : null] }));
};
